import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import paths from '../../config/paths';
import './styles.css';

// Existing brand assets
import MiniLogo from '../../assets/miniLogo.svg';
import CardIcon from '../../assets/img/cards.svg';
import PaypalIcon from '../../assets/img/paypal.svg';
import BankTransferIcon from '../../assets/img/bank-transfer.svg';
import FunctionIcon1 from '../../assets/functions/Icon1.svg';
import FunctionIcon2 from '../../assets/functions/Icon2.svg';
import FunctionIcon3 from '../../assets/functions/Icon3.svg';
import CheckIcon from '../../assets/checkIcon.svg';
import DHLLogo from '../../assets/brands/DHL.svg';
import FedExLogo from '../../assets/brands/FEDEX.svg';
import PaquetexpressLogo from '../../assets/brands/PAQUETEXPRESS.svg';

const HowItWorks: React.FC<any> = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className='how-it-works-page min-h-screen bg-gray-50 flex flex-col'>
      {/* ================= STICKY TOP NAVBAR ================= */}
      <header className='hiw-nav py-4 px-6 md:px-12 w-full'>
        <div className='max-w-7xl mx-auto flex items-center justify-between'>
          <Link to={paths.HOME} className='flex items-center space-x-3'>
            <img src={MiniLogo} alt='In a bit' className='h-8 md:h-10 w-auto' />
          </Link>

          {/* Desktop Nav Items */}
          <nav className='hidden md:flex items-center space-x-8'>
            <Link to={paths.HOME} className='hiw-nav-link'>
              Inicio
            </Link>
            <a href='#que-es' className='hiw-nav-link'>
              ¿Qué es In a bit?
            </a>
            <a href='#envios' className='hiw-nav-link'>
              ¿Cómo enviar?
            </a>
            <a href='#creditos-prepagados' className='hiw-nav-link font-semibold text-primary-inabit-red'>
              Créditos y Facturación
            </a>
            <a href='#faq' className='hiw-nav-link'>
              Preguntas
            </a>
          </nav>

          {/* Auth Actions */}
          <div className='hidden md:flex items-center space-x-4'>
            <Link
              to={paths.LOGIN}
              className='text-sm font-semibold px-4 py-2 text-gray-700 hover:text-primary-inabit-red transition-colors'
            >
              Iniciar Sesión
            </Link>
            <Link
              to={paths.SIGN_UP}
              className='btn-primary-inabit text-sm font-semibold px-5 py-2.5 rounded-full inline-block text-white shadow-md'
            >
              Crear Cuenta
            </Link>
          </div>

          {/* Mobile hamburger button */}
          <button
            type='button'
            className='md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 focus:outline-none'
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              {mobileMenuOpen ? (
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
              ) : (
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Drawer */}
        {mobileMenuOpen && (
          <div className='md:hidden mt-4 pt-4 border-t border-gray-100 flex flex-col space-y-3 pb-2'>
            <Link to={paths.HOME} className='hiw-nav-link px-2 py-1'>
              Inicio
            </Link>
            <a href='#que-es' onClick={() => setMobileMenuOpen(false)} className='hiw-nav-link px-2 py-1'>
              ¿Qué es In a bit?
            </a>
            <a href='#envios' onClick={() => setMobileMenuOpen(false)} className='hiw-nav-link px-2 py-1'>
              ¿Cómo enviar?
            </a>
            <a href='#creditos-prepagados' onClick={() => setMobileMenuOpen(false)} className='hiw-nav-link px-2 py-1 text-primary-inabit-red font-bold'>
              Créditos Prepagados
            </a>
            <a href='#faq' onClick={() => setMobileMenuOpen(false)} className='hiw-nav-link px-2 py-1'>
              Preguntas Frecuentes
            </a>
            <div className='pt-2 flex flex-col space-y-2'>
              <Link to={paths.LOGIN} className='text-center py-2 font-semibold text-gray-700 bg-gray-100 rounded-lg'>
                Iniciar Sesión
              </Link>
              <Link to={paths.SIGN_UP} className='btn-primary-inabit text-center py-2.5 font-semibold text-white rounded-lg'>
                Registrarse Gratis
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* ================= HERO SECTION ================= */}
      <section className='hiw-hero text-white py-16 md:py-24 px-6 md:px-12'>
        <div className='max-w-5xl mx-auto text-center relative z-10'>
          <div className='inline-flex items-center space-x-2 bg-white bg-opacity-10 backdrop-blur-md px-4 py-1.5 rounded-full mb-6 border border-white border-opacity-20'>
            <span className='w-2 h-2 rounded-full bg-primary-inabit-red animate-pulse' />
            <span className='text-xs md:text-sm font-medium tracking-wide uppercase text-gray-200'>
              Servicios de Envío y Paquetería
            </span>
          </div>

          <h1 className='text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight brand-title-font'>
            ¿Cómo funciona <span className='text-primary-inabit-red'>In a bit</span>?
          </h1>

          <p className='text-base sm:text-xl text-gray-200 max-w-3xl mx-auto font-light leading-relaxed mb-10'>
            Conoce cómo gestionamos tus envíos nacionales e internacionales con las mejores paqueterías, y cómo funciona nuestro sistema transparente de <strong>créditos prepagados</strong> integrado con tu tienda Shopify.
          </p>

          <div className='flex flex-col sm:flex-row items-center justify-center gap-4'>
            <Link
              to={paths.SIGN_UP}
              className='btn-primary-inabit w-full sm:w-auto px-8 py-4 rounded-full font-bold text-base shadow-xl'
            >
              Registrarse en In a bit
            </Link>
            <a
              href='#creditos-prepagados'
              className='btn-secondary-inabit w-full sm:w-auto px-8 py-4 rounded-full font-semibold text-base shadow-md'
            >
              ¿Cómo se compran créditos? ↓
            </a>
          </div>
        </div>
      </section>

      {/* ================= SECTION 1: HOW IN A BIT WORKS ================= */}
      <section id='que-es' className='py-20 px-6 md:px-12 max-w-7xl mx-auto w-full'>
        <div className='text-center max-w-3xl mx-auto mb-16'>
          <span className='hiw-badge hiw-badge-red mb-3'>Solución Logística Integral</span>
          <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 brand-title-font'>
            Tu centro de envíos inteligente
          </h2>
          <p className='text-gray-600 text-lg leading-relaxed'>
            In a bit conecta tu negocio y tu tienda online con las paqueterías más confiables del mundo bajo tarifas preferenciales por volumen, sin que tengas que firmar contratos individuales ni cumplir mínimos obligatorios de envíos.
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
          <div className='hiw-card p-8 flex flex-col'>
            <div className='w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mb-6'>
              <img src={FunctionIcon1} alt='Multi-paquetería' className='w-8 h-8' />
            </div>
            <h3 className='text-xl font-bold text-gray-900 mb-3'>Multi-paquetería en un solo clic</h3>
            <p className='text-gray-600 leading-relaxed text-sm flex-grow'>
              Accede a todas las paqueterías Nacionales de México desde una sola cuenta centralizada. Compara tiempos de entrega (express 24 hrs o estándar económico) y elige la mejor opción para cada paquete.
            </p>
            <div className='mt-6 pt-4 border-t border-gray-100 flex items-center text-primary-inabit-red font-semibold text-xs uppercase tracking-wider'>
              Tarifas preferenciales garantizadas
            </div>
          </div>

          <div className='hiw-card p-8 flex flex-col'>
            <div className='w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mb-6'>
              <img src={FunctionIcon2} alt='Cotizador Automático' className='w-8 h-8' />
            </div>
            <h3 className='text-xl font-bold text-gray-900 mb-3'>Cotización y cálculo en tiempo real</h3>
            <p className='text-gray-600 leading-relaxed text-sm flex-grow'>
              Nuestra tecnología calcula pesos volumétricos y tarifas exactas entre códigos postales de origen y destino al instante, integrándose directo al checkout de tu comercio para cobrar el envío justo a tus clientes.
            </p>
            <div className='mt-6 pt-4 border-t border-gray-100 flex items-center text-primary-inabit-blue font-semibold text-xs uppercase tracking-wider'>
              Algoritmo de optimización de costos
            </div>
          </div>

          <div className='hiw-card p-8 flex flex-col'>
            <div className='w-14 h-14 rounded-2xl bg-green-50 flex items-center justify-center mb-6'>
              <img src={FunctionIcon3} alt='Rastreo Integral' className='w-8 h-8' />
            </div>
            <h3 className='text-xl font-bold text-gray-900 mb-3'>Rastreo y recolecciones</h3>
            <p className='text-gray-600 leading-relaxed text-sm flex-grow'>
              Programa recolecciones gratuitas a la puerta de tu bodega u hogar, entrega en sucursales autorizadas y monitorea el estado del paquete con folios de rastreo en tiempo real para ti y tu comprador.
            </p>
            <div className='mt-6 pt-4 border-t border-gray-100 flex items-center text-green-600 font-semibold text-xs uppercase tracking-wider'>
              Notificaciones y comprobantes en PDF
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECTION 2: HOW SHIPPING WORKS ================= */}
      <section id='envios' className='py-20 px-6 md:px-12 bg-white border-t border-b border-gray-200'>
        <div className='max-w-7xl mx-auto'>
          <div className='text-center max-w-3xl mx-auto mb-16'>
            <span className='hiw-badge hiw-badge-blue mb-3'>Paso a Paso</span>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 brand-title-font'>
              ¿Cómo funciona el proceso de envío?
            </h2>
            <p className='text-gray-600 text-lg'>
              Desde que recibes un pedido hasta que se entrega en las manos de tu cliente.
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-4 gap-8 relative'>
            {/* Step 1 */}
            <div className='hiw-card p-6 flex flex-col items-start'>
              <div className='step-number bg-primary-inabit-red text-white mb-4'>1</div>
              <h4 className='text-lg font-bold text-gray-900 mb-2'>1. Cotizar o Recibir Pedido</h4>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Tu cliente hace una compra en tu tienda Shopify o generas una cotización manual en tu panel de In a bit con el origen, destino y medidas del paquete.
              </p>
            </div>

            {/* Step 2 */}
            <div className='hiw-card p-6 flex flex-col items-start'>
              <div className='step-number bg-primary-inabit-blue text-white mb-4'>2</div>
              <h4 className='text-lg font-bold text-gray-900 mb-2'>2. Generar Guía al Instante</h4>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Con un solo clic, se crea la guía oficial en PDF (formato estándar o térmico 4x6). El costo se descuenta de tu saldo de créditos prepagados sin esperas.
              </p>
            </div>

            {/* Step 3 */}
            <div className='hiw-card p-6 flex flex-col items-start'>
              <div className='step-number bg-purple-800 text-white mb-4'>3</div>
              <h4 className='text-lg font-bold text-gray-900 mb-2'>3. Empacar y Entregar</h4>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Pega la etiqueta impresa en tu caja o sobre. Puedes solicitar recolección automática o dejar el paquete en cualquier sucursal o centro de envío cercano.
              </p>
            </div>

            {/* Step 4 */}
            <div className='hiw-card p-6 flex flex-col items-start'>
              <div className='step-number bg-green-600 text-white mb-4'>4</div>
              <h4 className='text-lg font-bold text-gray-900 mb-2'>4. Rastreo y Notificaciones</h4>
              <p className='text-gray-600 text-sm leading-relaxed'>
                El número de seguimiento se sincroniza con la orden de Shopify. Tanto tú como tu comprador pueden rastrear cada evento hasta la entrega final.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECTION 3: PREPAID CREDITS (CRUCIAL SHOPIFY REQUIREMENT) ================= */}
      <section id='creditos-prepagados' className='py-20 px-6 md:px-12 bg-gray-50'>
        <div className='max-w-7xl mx-auto'>
          {/* Prominent notice banner required by Shopify */}
          <div className='shopify-notice-box p-8 md:p-10 mb-16 shadow-lg'>
            <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6'>
              <div className='max-w-3xl'>
                <div className='inline-flex items-center space-x-2 bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3'>
                  Información Importante para Comerciantes de Shopify
                </div>
                <h3 className='text-2xl md:text-3xl font-bold text-gray-900 mb-3 brand-title-font'>
                  Facturación Independiente: Sistema de Créditos Prepagados
                </h3>
                <p className='text-gray-700 leading-relaxed text-sm md:text-base'>
                  Para generar guías de paquetería a través de la aplicación de In a bit en Shopify, <strong>las etiquetas de envío se financian mediante créditos prepagados adquiridos directamente en nuestra plataforma web</strong>. 
                  Shopify no procesa ni cobra las guías de paquetería en tu factura mensual de Shopify; en su lugar, gestionas tu saldo de forma segura, flexible y con facturación fiscal mexicana (CFDI) en In a bit.
                </p>
              </div>
              <div className='flex-shrink-0'>
                <Link
                  to={paths.SIGN_UP}
                  className='btn-primary-inabit px-6 py-3.5 rounded-xl font-bold text-white text-sm md:text-base shadow inline-block'
                >
                  Registrarte para Recargar →
                </Link>
              </div>
            </div>
          </div>

          <div className='text-center max-w-3xl mx-auto mb-16'>
            <span className='hiw-badge hiw-badge-green mb-3'>Transparencia Financiera</span>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 brand-title-font'>
              ¿Cómo se compran y utilizan los créditos prepagados?
            </h2>
            <p className='text-gray-600 text-lg'>
              Sin mensualidades forzosas ni comisiones ocultas. 1 Crédito = 1 Peso Mexicano (MXN).
            </p>
          </div>

          {/* Steps to buy credits */}
          <div className='grid grid-cols-1 md:grid-cols-3 gap-8 mb-16'>
            <div className='hiw-card p-8'>
              <div className='w-12 h-12 rounded-xl bg-red-100 text-primary-inabit-red flex items-center justify-center font-bold text-xl mb-6'>
                1
              </div>
              <h3 className='text-xl font-bold text-gray-900 mb-3'>Crea tu cuenta o inicia sesión</h3>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Regístrate en <Link to={paths.SIGN_UP} className='text-primary-inabit-red font-semibold hover:underline'>inabitmexico.com</Link> con tu correo electrónico y datos de negocio. Obtendrás tu panel administrativo de inmediato.
              </p>
            </div>

            <div className='hiw-card p-8'>
              <div className='w-12 h-12 rounded-xl bg-blue-100 text-primary-inabit-blue flex items-center justify-center font-bold text-xl mb-6'>
                2
              </div>
              <h3 className='text-xl font-bold text-gray-900 mb-3'>Elige tu monto y método de pago</h3>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Ingresa al apartado <strong>"Recargar Créditos"</strong> en tu dashboard. Elige la cantidad que deseas ingresar y selecciona tu forma de pago favorita.
              </p>
            </div>

            <div className='hiw-card p-8'>
              <div className='w-12 h-12 rounded-xl bg-green-100 text-green-600 flex items-center justify-center font-bold text-xl mb-6'>
                3
              </div>
              <h3 className='text-xl font-bold text-gray-900 mb-3'>Genera guías automáticamente</h3>
              <p className='text-gray-600 text-sm leading-relaxed'>
                Tu saldo se acredita de inmediato. Cada vez que generas una guía en Shopify o en el cotizador, el monto exacto del servicio se deduce de tu saldo.
              </p>
            </div>
          </div>

          {/* Payment Methods Supported */}
          <div className='bg-white rounded-3xl p-8 md:p-12 border border-gray-200 shadow-sm'>
            <h3 className='text-2xl font-bold text-gray-900 text-center mb-8 brand-title-font'>
              Métodos de Pago Disponibles en Nuestra Plataforma
            </h3>

            <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
              <div className='border border-gray-100 bg-gray-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-md transition-all'>
                <img src={CardIcon} alt='Tarjetas' className='h-14 mx-auto mb-4' />
                <h4 className='font-bold text-lg text-gray-900 mb-2'>Tarjetas de Crédito y Débito</h4>
                <p className='text-gray-600 text-xs leading-relaxed'>
                  Procesado de forma 100% segura mediante Stripe. Aceptamos Visa, MasterCard y American Express. Acreditación en tiempo real.
                </p>
              </div>

              <div className='border border-gray-100 bg-gray-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-md transition-all'>
                <img src={PaypalIcon} alt='PayPal' className='h-14 mx-auto mb-4' />
                <h4 className='font-bold text-lg text-gray-900 mb-2'>PayPal</h4>
                <p className='text-gray-600 text-xs leading-relaxed'>
                  Paga con tu cuenta o saldo PayPal con total protección al comprador y confirmación instantánea de tus recargas.
                </p>
              </div>

              <div className='border border-gray-100 bg-gray-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-md transition-all'>
                <img src={BankTransferIcon} alt='SPEI' className='h-14 mx-auto mb-4' />
                <h4 className='font-bold text-lg text-gray-900 mb-2'>Transferencia SPEI</h4>
                <p className='text-gray-600 text-xs leading-relaxed'>
                  Transfiere desde tu banca móvil a través de CLABE interbancaria personalizada, ideal para recargas corporativas o de mayor volumen.
                </p>
              </div>
            </div>

            {/* Facturación banner */}
            <div className='mt-8 pt-6 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-600'>
              <div className='flex items-center space-x-3'>
                <img src={CheckIcon} alt='Facturación' className='w-5 h-5 text-green-500' />
                <span>
                  <strong>Facturación CFDI 4.0:</strong> Descarga tus facturas fiscales XML y PDF de cada recarga directamente desde la pestaña "Facturas".
                </span>
              </div>
              <div className='flex items-center space-x-3'>
                <img src={CheckIcon} alt='Sin caducidad' className='w-5 h-5 text-green-500' />
                <span>
                  <strong>Tus créditos no caducan:</strong> Usa tu saldo a tu propio ritmo según la demanda de ventas de tu tienda.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECTION 4: SHOPIFY INTEGRATION (HIDDEN WHILE IN REVIEW) ================= */}
      {/* 
      <section id='shopify' className='py-20 px-6 md:px-12 bg-white'>
        <div className='max-w-7xl mx-auto'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center'>
            <div>
              <span className='hiw-badge hiw-badge-purple mb-3'>Shopify App Store</span>
              <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6 brand-title-font leading-tight'>
                Integra tu tienda Shopify en menos de 5 minutos
              </h2>
              <p className='text-gray-600 text-base md:text-lg mb-6 leading-relaxed'>
                Nuestra aplicación oficial conecta tu inventario y pedidos de Shopify directamente con el motor de envíos de In a bit. Sigue estos sencillos pasos:
              </p>

              <div className='space-y-4'>
                <div className='flex items-start space-x-4'>
                  <div className='w-8 h-8 rounded-full bg-primary-inabit-purple text-white flex items-center justify-center font-bold text-sm flex-shrink-0 mt-1'>
                    1
                  </div>
                  <div>
                    <h4 className='font-bold text-gray-900 text-base'>Instala la App de In a bit</h4>
                    <p className='text-gray-600 text-sm'>
                      Descarga nuestra aplicación desde la Shopify App Store en tu panel de administración de Shopify.
                    </p>
                  </div>
                </div>

                <div className='flex items-start space-x-4'>
                  <div className='w-8 h-8 rounded-full bg-primary-inabit-purple text-white flex items-center justify-center font-bold text-sm flex-shrink-0 mt-1'>
                    2
                  </div>
                  <div>
                    <h4 className='font-bold text-gray-900 text-base'>Crea tu cuenta y copia tu API Key</h4>
                    <p className='text-gray-600 text-sm'>
                      <Link to={paths.SIGN_UP} className='text-primary-inabit-red font-semibold hover:underline'>Regístrate en In a bit</Link>, entra a tu perfil y copia tu API Key para autorizar la sincronización con tu tienda.
                    </p>
                  </div>
                </div>

                <div className='flex items-start space-x-4'>
                  <div className='w-8 h-8 rounded-full bg-primary-inabit-purple text-white flex items-center justify-center font-bold text-sm flex-shrink-0 mt-1'>
                    3
                  </div>
                  <div>
                    <h4 className='font-bold text-gray-900 text-base'>Recarga créditos en tu panel</h4>
                    <p className='text-gray-600 text-sm'>
                      Abastece tu cuenta con saldo inicial en la sección de créditos para poder expedir guías de manera continua.
                    </p>
                  </div>
                </div>

                <div className='flex items-start space-x-4'>
                  <div className='w-8 h-8 rounded-full bg-primary-inabit-purple text-white flex items-center justify-center font-bold text-sm flex-shrink-0 mt-1'>
                    4
                  </div>
                  <div>
                    <h4 className='font-bold text-gray-900 text-base'>Genera guías con 1 clic</h4>
                    <p className='text-gray-600 text-sm'>
                      Cuando recibas una orden, visualiza el costo, haz clic en "Generar Envío" y descarga tu etiqueta lista para imprimir.
                    </p>
                  </div>
                </div>
              </div>

              <div className='mt-8 pt-4'>
                <Link
                  to={paths.SIGN_UP}
                  className='btn-primary-inabit px-8 py-3.5 rounded-full font-bold text-white text-base shadow inline-block'
                >
                  Comenzar ahora →
                </Link>
              </div>
            </div>

            <div className='bg-gradient-to-br from-gray-900 via-green-950 to-gray-900 p-8 rounded-3xl text-white shadow-2xl border border-gray-800 relative'>
              <div className='flex items-center justify-between border-b border-gray-700 pb-4 mb-6'>
                <div className='flex items-center space-x-2'>
                  <span className='w-3 h-3 rounded-full bg-red-500 inline-block' />
                  <span className='w-3 h-3 rounded-full bg-yellow-500 inline-block' />
                  <span className='w-3 h-3 rounded-full bg-green-500 inline-block' />
                  <span className='ml-2 text-xs text-gray-400 font-mono'>Dashboard In a bit & Shopify</span>
                </div>
                <span className='text-xs bg-green-500 text-black font-semibold px-2 py-0.5 rounded'>Conectado</span>
              </div>

              <div className='space-y-4 text-sm font-sans'>
                <div className='bg-gray-800 bg-opacity-70 p-4 rounded-xl border border-gray-700 flex justify-between items-center'>
                  <div>
                    <div className='text-xs text-gray-400'>Saldo disponible en créditos:</div>
                    <div className='text-2xl font-bold text-green-400'>$2,450.00 MXN</div>
                  </div>
                  <Link
                    to={paths.LOGIN}
                    className='bg-primary-inabit-red hover:bg-red-600 text-white text-xs font-bold px-3 py-2 rounded-lg transition-colors'
                  >
                    + Recargar
                  </Link>
                </div>

                <div className='bg-gray-800 bg-opacity-70 p-4 rounded-xl border border-gray-700 space-y-2'>
                  <div className='flex justify-between text-xs text-gray-400'>
                    <span>Orden #1024 (Shopify)</span>
                    <span className='text-blue-400'>Listo para enviar</span>
                  </div>
                  <div className='text-sm font-semibold'>Destino: Monterrey, N.L. (CP 64000)</div>
                  <div className='text-xs text-gray-300 flex justify-between pt-2 border-t border-gray-700'>
                    <span>Servicio: DHL Express (Día siguiente)</span>
                    <span className='font-bold text-white'>$145.00 MXN</span>
                  </div>
                </div>

                <div className='p-3 bg-blue-900 bg-opacity-30 border border-blue-700 rounded-xl text-xs text-blue-200'>
                  ✓ El saldo se descuenta de tu cuenta In a bit de forma automática y la orden en Shopify se actualiza con su guía y link de rastreo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* ================= SECTION 5: FAQ ================= */}
      <section id='faq' className='py-20 px-6 md:px-12 bg-gray-50 border-t border-gray-200'>
        <div className='max-w-4xl mx-auto'>
          <div className='text-center mb-16'>
            <span className='hiw-badge hiw-badge-blue mb-3'>Resolvemos tus dudas</span>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 brand-title-font'>
              Preguntas Frecuentes
            </h2>
            <p className='text-gray-600 text-base'>
              Todo lo que necesitas saber sobre el funcionamiento del servicio y la facturación.
            </p>
          </div>

          <div className='space-y-4'>
            <details className='faq-details' open>
              <summary className='faq-summary text-gray-900 text-base md:text-lg'>
                <span>¿Por qué las guías se cobran con créditos prepagados y no a través de Shopify?</span>
                <span className='text-primary-inabit-red text-xl font-bold'>+</span>
              </summary>
              <div className='px-6 pb-6 text-gray-600 text-sm leading-relaxed'>
                Las paqueterías con las que operamos (DHL, FedEx, UPS, etc.) requieren liquidación inmediata y facturación fiscal directa en México (CFDI 4.0 deducible ante el SAT). El modelo prepagado te permite pagar únicamente por los envíos que realizas, sin suscripciones mensuales fijas ni comisiones adicionales en tu factura de Shopify.
              </div>
            </details>

            <details className='faq-details'>
              <summary className='faq-summary text-gray-900 text-base md:text-lg'>
                <span>¿Qué ocurre si se agota mi saldo de créditos?</span>
                <span className='text-primary-inabit-red text-xl font-bold'>+</span>
              </summary>
              <div className='px-6 pb-6 text-gray-600 text-sm leading-relaxed'>
                Si tu saldo es insuficiente para expedir una nueva guía, el sistema te notificará de inmediato. Tan pronto como realices una recarga con tarjeta de débito/crédito, PayPal o transferencia SPEI, tu saldo se actualizará al instante y podrás continuar generando tus etiquetas sin perder información de tus pedidos.
              </div>
            </details>

            <details className='faq-details'>
              <summary className='faq-summary text-gray-900 text-base md:text-lg'>
                <span>¿Tienen costo las recolecciones a domicilio?</span>
                <span className='text-primary-inabit-red text-xl font-bold'>+</span>
              </summary>
              <div className='px-6 pb-6 text-gray-600 text-sm leading-relaxed'>
                Las recolecciones están incluidas en la mayoría de los servicios de paquetería comercial sin costo extra, dependiendo de tu código postal. También puedes entregar tus paquetes directamente en sucursales autorizadas de cada paquetería o en nuestras sucursales In a bit.
              </div>
            </details>

            <details className='faq-details'>
              <summary className='faq-summary text-gray-900 text-base md:text-lg'>
                <span>¿Cómo obtengo mi factura fiscal (CFDI) por la compra de créditos?</span>
                <span className='text-primary-inabit-red text-xl font-bold'>+</span>
              </summary>
              <div className='px-6 pb-6 text-gray-600 text-sm leading-relaxed'>
                En tu perfil de usuario puedes registrar tus datos fiscales (RFC, Razón Social, Régimen Fiscal y Uso de CFDI). Cada vez que realizas una recarga de créditos, el sistema emite automáticamente tu comprobante fiscal digital con desglose de IVA para que lo descargues en PDF y XML desde la sección "Facturas".
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA BANNER ================= */}
      <section className='py-16 px-6 md:px-12 bg-gradient-to-r from-primary-inabit-green via-primary-inabit-purple to-gray-900 text-white text-center'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4 brand-title-font'>
            ¿Listo para simplificar los envíos de tu tienda?
          </h2>
          <p className='text-gray-200 text-base md:text-lg mb-8 max-w-2xl mx-auto'>
            Crea tu cuenta gratuita hoy mismo, adquiere tus primeros créditos y empieza a enviar a todo México y el mundo con las mejores tarifas.
          </p>
          <div className='flex flex-col sm:flex-row justify-center gap-4'>
            <Link
              to={paths.SIGN_UP}
              className='btn-primary-inabit px-8 py-4 rounded-full font-bold text-white text-base shadow-xl'
            >
              Registrarse Gratis en In a bit
            </Link>
            <Link
              to={paths.LOGIN}
              className='btn-secondary-inabit px-8 py-4 rounded-full font-bold text-base shadow-md'
            >
              Ya tengo cuenta, Iniciar Sesión
            </Link>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className='bg-gray-900 text-gray-400 py-12 px-6 md:px-12 border-t border-gray-800 text-sm'>
        <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 mb-12'>
          <div>
            <img src={MiniLogo} alt='In a bit' className='h-8 w-auto mb-4 filter brightness-200' />
            <p className='text-xs text-gray-400 leading-relaxed'>
              Plataforma tecnológica de soluciones de logística y envíos para comercio electrónico, negocios y particulares.
            </p>
          </div>
          <div>
            <h4 className='text-white font-bold mb-3 text-sm'>Navegación</h4>
            <ul className='space-y-2 text-xs'>
              <li><Link to={paths.HOME} className='hover:text-white transition-colors'>Inicio</Link></li>
              <li><Link to={paths.HOW_IT_WORKS} className='hover:text-white transition-colors'>¿Cómo funciona?</Link></li>
              <li><Link to={paths.TRACKING} className='hover:text-white transition-colors'>Rastreo de Guías</Link></li>
              <li><Link to={paths.SIGN_UP} className='hover:text-white transition-colors'>Registro de Clientes</Link></li>
            </ul>
          </div>
          <div>
            <h4 className='text-white font-bold mb-3 text-sm'>Contacto y Soporte</h4>
            <p className='text-xs leading-relaxed'>ventas@inabitmexico.com</p>
            <p className='text-xs leading-relaxed mt-1'>(+52) 442 223 0688</p>
            <p className='text-xs leading-relaxed mt-1'>Querétaro, Qro. México</p>
          </div>
          <div>
            <h4 className='text-white font-bold mb-3 text-sm'>Políticas y Legal</h4>
            <ul className='space-y-2 text-xs'>
              <li><Link to={paths.TERMS} className='hover:text-white transition-colors'>Términos y Condiciones</Link></li>
              <li><Link to={paths.PRIVACY_POLICY} className='hover:text-white transition-colors'>Aviso de Privacidad</Link></li>
              <li><Link to={paths.CHANGES_POLICY} className='hover:text-white transition-colors'>Políticas de Devolución</Link></li>
            </ul>
          </div>
        </div>
        <div className='max-w-7xl mx-auto pt-6 border-t border-gray-800 text-center text-xs text-gray-500'>
          © {new Date().getFullYear()} In a bit México. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
};

export default withRouter(HowItWorks);
